import { Text } from "@musa.tech/design-system";
import { CarbonTreemapGrid } from "./CarbonTreemapGrid";
import type { MaterialCarbonBreakdown } from "@/integrations/agreements/client";

interface CarbonByMaterialWidgetProps {
  entries: MaterialCarbonBreakdown[];
}

/**
 * Widget "Carbono evitado por resíduo" (Figma node 345:16134) — blocos com área
 * proporcional ao CO₂ que cada resíduo deixou de emitir no período filtrado.
 *
 * Só aparecem resíduos com fator de conversão cadastrado: o cálculo descarta os
 * demais na origem. Vale o dado real, não o mock do design.
 */
export const CarbonByMaterialWidget = ({ entries }: CarbonByMaterialWidgetProps) => (
  <div className="flex h-full w-full flex-col gap-4 rounded-2xl bg-white p-6 transition-shadow duration-200 hover:shadow-md motion-reduce:transition-none">
    <Text className="text-xl font-light leading-5 text-black">
      Carbono evitado por resíduo
    </Text>

    <CarbonTreemapGrid entries={entries} />
  </div>
);
